import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/minimize-icon.svg'


const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = { class: "flex flex-row" }
const _hoisted_3 = { class: "py-1" }
const _hoisted_4 = ["alt"]
const _hoisted_5 = { class: "py-1" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeviceMobileIcon = _resolveComponent("DeviceMobileIcon")!
  const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon")!
  const _component_DotsCircleHorizontalIcon = _resolveComponent("DotsCircleHorizontalIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_LogoutIcon = _resolveComponent("LogoutIcon")!
  const _component_SparklesIcon = _resolveComponent("SparklesIcon")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _directive_svg_inline = _resolveDirective("svg-inline")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      !_ctx.isMobile && 'rounded-t-md',
      `${_ctx.backgroundClass} ${_ctx.textColorClass} select-none shadow-md z-10 transition-colors`,
    ]),
    ref: "container"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        (_ctx.canTransfer)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: _normalizeClass(["group p-3 rounded-md flex flex-col items-center text-xs font-medium cursor-pointer transition-all", [
            _ctx.showTransferOption ? 'visible' : 'invisible',
            _ctx.textColorClass,
          ]]),
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.initTransfer && _ctx.initTransfer(...args)), ["prevent"]))
            }, [
              _createVNode(_component_DeviceMobileIcon, {
                class: "h-6 w-6 stroke-2",
                "aria-hidden": "true"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.t("messengerHeader.moveButtonText")), 1)
            ], 2))
          : (_ctx.backAction)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: _normalizeClass([[_ctx.textColorClass], "group p-3 rounded-md flex flex-col items-center text-xs font-medium cursor-pointer transition-all"]),
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.backAction && _ctx.backAction(...args)), ["prevent"]))
              }, [
                _createVNode(_component_ChevronLeftIcon, {
                  class: "h-6 w-6 stroke-2",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.t("messengerHeader.backButtonText")), 1)
              ], 2))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Menu, {
          as: "div",
          class: "relative inline-block text-left z-50"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_MenuButton, {
                class: _normalizeClass([[_ctx.textColorClass], "z-50 group p-3 rounded-md flex flex-col items-center text-xs font-medium cursor-pointer transition-all outline-none"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DotsCircleHorizontalIcon, {
                    class: "stroke-2 outline-none h-6 w-6",
                    alt: "example svg image"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("messengerHeader.actionsButtonText")), 1)
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _createVNode(_Transition, {
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "transform opacity-0 scale-95",
              "enter-to-class": "transform opacity-100 scale-100",
              "leave-active-class": "transition ease-in duration-75",
              "leave-from-class": "transform opacity-100 scale-100",
              "leave-to-class": "transform opacity-0 scale-95"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MenuItems, { class: "origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_MenuItem, null, {
                        default: _withCtx(({ active }) => [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('minimize')), ["prevent"])),
                            class: _normalizeClass([
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'group flex items-center px-4 py-2 text-sm content-center  transition-colors',
                    ])
                          }, [
                            _withDirectives(_createElementVNode("img", {
                              class: "mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 transition-colors fill-current",
                              src: _imports_0,
                              alt: _ctx.t('messengerHeader.minimizeButtonText')
                            }, null, 8, _hoisted_4), [
                              [_directive_svg_inline]
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.t("messengerHeader.minimizeButtonText")), 1)
                          ], 2)
                        ]),
                        _: 1
                      }),
                      (_ctx.canEndConversation)
                        ? (_openBlock(), _createBlock(_component_MenuItem, { key: 0 }, {
                            default: _withCtx(({ active }) => [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.endConversation && _ctx.endConversation(...args)), ["prevent"])),
                                class: _normalizeClass([
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'group flex items-center px-4 py-2 text-sm content-center  transition-colors',
                    ])
                              }, [
                                _createVNode(_component_LogoutIcon, {
                                  class: "mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 transition-colors",
                                  "aria-hidden": "true"
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("messengerHeader.endConversationButtonText")), 1)
                              ], 2)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_MenuItem, null, {
                        default: _withCtx(({ active }) => [
                          _createElementVNode("a", {
                            href: `${_ctx.productWebsite}/?utm_medium=chat_widget&utm_campaign=powered_by_in_dropdown`,
                            target: "_blank",
                            class: _normalizeClass([
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'group flex items-center px-4 py-2 text-sm content-center  transition-colors',
                    ])
                          }, [
                            _createVNode(_component_SparklesIcon, {
                              class: "mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 transition-colors",
                              "aria-hidden": "true"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.t("messengerHeader.getThisWidgetText")), 1)
                          ], 10, _hoisted_6)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "#",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('minimize')), ["prevent"])),
              class: _normalizeClass([[_ctx.textColorClass], "z-50 group p-3 rounded-md flex flex-col items-center text-xs font-medium cursor-pointer transition-all outline-none"])
            }, [
              _withDirectives(_createElementVNode("img", {
                class: "stroke-2 outline-none h-6 w-6 fill-current",
                src: _imports_0,
                alt: _ctx.t('messengerHeader.minimizeButtonText')
              }, null, 8, _hoisted_7), [
                [_directive_svg_inline]
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.t("messengerHeader.minimizeButtonText")), 1)
            ], 2))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}